export const getStyleProp = (prop, key) => ({
  theme
}) => theme[prop][key];